import { Button, Col, Input, Select, Row } from "antd";
import { useNavigate } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";

export const initialFilterState = {
  GroupName: "",
  GroupDesc: "",
  OemNo: null,
};

export const DealerGroupFilter = ({
  filter,
  setFilter,
  setParams,
  setPagination,
  refetch,
  setShowModal,
  selectedRowKeys,
}) => {
  const navigate = useNavigate();
  const logData = JSON.parse(sessionStorage.getItem("userData"));
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/dealers/options/`;
  const { data: optionData } = useGet(optionUrl);
  const modifiedOems = getModifiedResponse(optionData, "oems");

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = () => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        filterDict[key] = filter[key];
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";
    if (isEmpty) {
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "GroupNo",
        order: "desc",
        page: 1,
        ...filterDict,
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(params);
      refetch();
    }
  };

  const handleReset = () => {
    setFilter(initialFilterState);
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    setParams({
      limit: 10,
      sort_by: "GroupNo",
      order: "desc",
    });
    refetch();
  };

  return (
    <div className="mb-4">
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              placeholder="Name"
              value={filter.GroupName}
              onChange={handleFilterChange}
              name="GroupName"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              placeholder="Description"
              value={filter.GroupDesc}
              onChange={handleFilterChange}
              name="GroupDesc"
            />
          </Col>
          {![4, 5, 6].includes(logData?.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="OEM"
                optionFilterProp="label"
                value={
                  filter.OemNo || typeof filter.OemNo === "number"
                    ? Number(filter.OemNo)
                    : null
                }
                onChange={(value) => setFilter({ ...filter, OemNo: value })}
                options={modifiedOems}
                style={{ width: "100%" }}
              />
            </Col>
          )}
        </Row>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="flex justify-between my-4 flex-nowrap min-w-[610px]">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button className="reset-button" onClick={handleReset}>
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
            <Button
              type="primary"
              className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
              onClick={() => navigate("/group/add")}
            >
              <PlusOutlined />
              Add
            </Button>
            <Button
              type="primary"
              disabled={selectedRowKeys?.length === 0 ? true : false}
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <DeleteOutlined />
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
